import CloseIcon from "@material-ui/icons/Close";
import { createStyles, makeStyles } from "@material-ui/styles";
import { ImageUpload } from "components/ImageUpload/ImageUpload";
import TextField from "components/TextField";
import useText from "constants/text";
import { ProductContext } from "contexts/ProductContext";
import { Product } from "generated/graphql";
import React from "react";
import { renderImageArticle } from "utils";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    photoContent: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      margin: "0px 20px 0px 0px",
    },
    formContent: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      justifyContent: "space-between",
      width: "40%",
      margin: "0px 0px 0px 20px",
    },
    input: {
      marginBottom: 10,
    },
    text: {
      maxHeight: 100,
      minHeight: 100,
      maxWidth: "100%",
      minWidth: "100%",
    },
    img: {
      height: "100%",
      width: "100%",
      borderRadius: 7,
    },
    img_loaded: {
      width: 211.3,
      height: 234,
      position: "relative",
      marginBottom: 6,
    },
    closeIcon: {
      cursor: "pointer",
      color: "#f44336",
      marginRight: "auto",
      position: "absolute",
      right: 5,
      top: 5,
    },
  })
);

export function ArticleForm() {
  const styles = useStyles();
  const text = useText();
  const { product, setProduct, image, setImage, error, setError } = React.useContext(ProductContext);
  const onChange = (e: any) => {
    setError((prev: any) => ({ ...prev, submitted: false }));
    e.persist();
    setProduct((prev: Product) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <div className={styles.root}>
      <div className={styles.photoContent}>
        {image ? (
          <div className={styles.img_loaded}>
            <CloseIcon
              className={styles.closeIcon}
              onClick={() => {
                setImage(null);
              }}
            />
            <img src={renderImageArticle(image)} alt="product" className={styles.img} />
          </div>
        ) : (
          <ImageUpload onChange={(image) => setImage(image)} />
        )}
      </div>
      <div className={styles.formContent}>
        <TextField
          variant="outlined"
          label={text.text.all.name}
          className={styles.input}
          name="name"
          required={error.name.required}
          value={product.name}
          onChange={onChange}
          helperText={error.name.error && error.submitted && text.text.all.required_field}
          error={error.name.error && error.submitted}
        />

        <TextField
          variant="outlined"
          name="reference"
          label={text.text.catalog.reference_label}
          className={styles.input}
          value={product.reference}
          onChange={onChange}
          required={error.reference.required}
          helperText={error.reference.error && error.submitted && text.text.all.required_field}
          error={error.reference.error && error.submitted}
        />

        <TextField
          variant="outlined"
          name="description"
          multiline
          rows={3}
          label={text.text.catalog.description_label}
          value={product.description}
          onChange={onChange}
          rowsMax={6}
          className={styles.text}
          required={error.description.required}
          helperText={error.description.error && error.submitted && text.text.all.required_field}
          error={error.description.error && error.submitted}
        />
      </div>
    </div>
  );
}
